import {
    CONFIRMATION_PENDING,
    KontaktMegActionTypes,
    REGISTER_FAILED,
    REGISTER_PENDING,
    REGISTER_SUCCESS,
    RESET_STATE,
} from '../actions';

export interface KontaktMegState {
    registerPending: boolean;
    registerSuccess: boolean;
    hasError: boolean;
    confirmationPending: boolean;
}

const initialState: KontaktMegState = {
    registerPending: false,
    registerSuccess: false,
    hasError: false,
    confirmationPending: false,
};

// eslint-disable-next-line default-param-last
export default (state = initialState, action: KontaktMegActionTypes): KontaktMegState => {
    switch (action.type) {
        case REGISTER_PENDING:
            return {
                ...state,
                registerPending: true,
                confirmationPending: false,
            };
        case REGISTER_SUCCESS:
            return {
                ...state,
                registerSuccess: true,
                registerPending: false,
            };
        case REGISTER_FAILED:
            return {
                ...state,
                registerPending: false,
                hasError: !!action.error,
            };
        case CONFIRMATION_PENDING:
            return {
                ...state,
                confirmationPending: true,
            };
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
};
